var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.125 7.177C4.125 3.38 7.203.302 11 .302s6.875 3.078 6.875 6.875-3.078 6.875-6.875 6.875-6.875-3.078-6.875-6.875zm13.063 8.25H15.96c-3.052 1.836-6.872 1.835-9.921 0H4.812C2.155 15.427 0 17.582 0 20.24v1.031c0 .57.462 1.031 1.031 1.031H20.97c.57 0 1.031-.461 1.031-1.03V20.24c0-2.658-2.155-4.813-4.813-4.813z",
    clipRule: "evenodd"
  })));
};
export default SvgPerson;